// src/config.js
const DEFAULT_API = "/api";

// สำหรับ development: ใช้ proxy หรือ localhost:3001
// สำหรับ production: ใช้ environment variable หรือ default "/api"
const getApiBase = () => {
  // ตรวจสอบ environment variables (รองรับหลาย framework)
  if (typeof import.meta !== "undefined" && import.meta.env?.VITE_API_BASE) {
    return import.meta.env.VITE_API_BASE;
  }
  
  if (typeof process !== "undefined") {
    if (process.env.REACT_APP_API_BASE) {
      return process.env.REACT_APP_API_BASE;
    }
    if (process.env.NEXT_PUBLIC_API_BASE) {
      return process.env.NEXT_PUBLIC_API_BASE;
    }
  }
  
  // Development mode: ใช้ absolute URL เพื่อให้แน่ใจว่าจะเรียก backend ได้
  // Production: ใช้ relative path (assume same domain)
  const isDevelopment = 
    typeof process !== "undefined" && 
    process.env.NODE_ENV === "development";
  
  if (isDevelopment) {
    // ใช้ absolute URL ใน development เพื่อให้เรียก backend โดยตรง
    // Backend อยู่ที่ http://localhost:3001
    return "http://localhost:3001/api";
  }
  
  return DEFAULT_API;
};

export const API_BASE = getApiBase();

// Log API_BASE ใน development เพื่อ debug
if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
  console.log("[Config] API_BASE:", API_BASE);
}

